var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-loader modal-mask"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"dual-ring"})])])])
}]

export { render, staticRenderFns }